<template>
  <WellModalContent 
    class="pt-10"
    @close="$attrs._close()"
    size="small"
  >
    <span class="mb-6 block">
      INVITE A FRIEND
    </span>
    <h1 class="text-4.5xl">
      {{ event.event_name }}
    </h1>

    <InstructorsStack
      class="mt-6"
      :instructors="event.instructors"
      size="20"
    />
    
    <div class="flex flex-col gap-4 mt-6">
      <button class="button-dark-outlined button-lg flex items-center gap-3" @click="copyLink">
        <WellIcon icon="link-01" :size="24" />
        COPY LINK
      </button>
      <button class="button-dark-outlined button-lg flex items-center gap-3" @click="shareOnX">
        <WellIcon icon="x-share" :size="24" type="custom-icons" />
        SHARE ON X
      </button>
      <button class="button-dark-outlined button-lg flex items-center gap-3" @click="shareViaEmail">
        <WellIcon icon="mail-01" :size="24" />
        SHARE VIA EMAIL
      </button>
      <button class="button-dark-outlined button-lg flex items-center gap-3" @click="shareOnFacebook">
        <WellIcon icon="facebook-share" :size="24" type="custom-icons" />
        SHARE ON FACEBOOK
      </button>
    </div>
  </WellModalContent>
</template>

<script lang="ts" setup>
import WellModalContent from '~/components/common/WellModalContent.vue'
import WellIcon from '~/components/common/WellIcon.vue'
import InstructorsStack from '@/components/events/InstructorsStack.vue'
import { useClipboard } from '@vueuse/core'

const toast = useToast();

const props = defineProps<{
  event: EventResponse,
}>()

const { copy } = useClipboard()

const copyLink = () => {
  copy(window.location.href)
  console.log('copying link')
  toast.add({ severity: 'contrast', summary: 'Copied!', detail: 'Link copied to clipboard', life: 3000 })
}

const shareOnX = () => {
  const shareText = props.event.event_name;
  const shareUrl = window.location.href;
  const encodedText = encodeURIComponent(`${shareText} ${shareUrl}`);
  window.open(`https://x.com/intent/tweet?text=${encodedText}`, '_blank');
}

const shareViaEmail = () => {
  const shareText = props.event.event_name;
  const shareUrl = window.location.href;
  const encodedText = encodeURIComponent(`${shareText} ${shareUrl}`);
  window.open(`mailto:?subject=${shareText}&body=${encodedText}`, '_blank')
}

const shareOnFacebook = () => {
  const shareUrl = window.location.href;
  const encodedUrl = encodeURIComponent(shareUrl);
  window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`, '_blank');
}
</script>